(function ($) {
	$.mainMenu = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			MainMenu = (function ($c, o) {
				var defaults = {
					trigger: '.main-header__toggle',
					mainLogo: '.main-header__brand',
					menuLogo: '.main-navigation__brand',
					nav: '.main-navigation',
					menu: '.main-navigation__menus',
					close: '.main-navigation__close',
					back: '.main-navigation__back',
					over: '.main-navigation__over',
					loadingBrand: '.main-loading__brand',
					loadingLoader: '.main-loading__loader'
				}; 

				var _o = {},
					_ww = 0, // Window Width
					_wh = 0, // Window Height
					_l1aw = 0, // Main Logo Arrow Width

					tli = null, // Timeline In
					tlo = null, // Timeline Out
					tln = null, // Timeline for the Navigation
					tlno = null, // Timeline for the Navigation Out
					tlt = null, // Timeline for the Trigger
					tltr = null, // Timeline for the Trigger rollover

					lbx = 0, // Loading Bar X (for animating out)

					isMobile = false, // Is Mobile

					$w = null, // Window

					$t = null, // Trigger
						$tb = null, // Top Bar
						$cb = null, // Center Bar
						$bb = null, // Bottom Bar
						$tt = null, // Trigger Text
						$tbk = null, // Trigger Back
						$th = null, // Trigger Hover

					$l1 = null, // Main Logo
						$l1a = null, // Main Logo Arrow
						$l1l = null, // Main Logo Logo
					$l2 = null, // Menu Logo

					$n = null, // Navigation
					$m = null, // Menu Container
						$mi = null, // Menu Links
					$n2 = null, // Secondary Navigation
						$n2i = null, // Secondary Navigation Links
					$ns = null, // Social Navigation

					$cbtn = null, // Close Button
					$cbt = null, // Close Bar Top
					$cbb = null, // Close Bar Bottom
					$b = null, // Back
					$o = null, // Over

					$lb = null, // Loading Brand
					$ll = null // Loading Loader
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);

					$w = $(window);
					$t = $(_o.trigger);
						$tb = $('.top', $t);
						$cb = $('.cen', $t);
						$bb = $('.bot', $t);
						$tt = $('> span', $t);
						$tbk = $(_o.trigger + '--back', $t);
						$th = $(_o.trigger + '--hover', $t);
					
					$l1 = $(_o.mainLogo);
						$l1a = $(_o.mainLogo + '--arrow');
						$l1l = $(_o.mainLogo + '--logo');
					$l2 = $(_o.menuLogo);

					$n = $(_o.nav);
					$m = $(_o.menu);
						$mi = $('.primary-navigation > .navigation__item > .navigation__item--link');
					$n2 = $('.secondary-navigation');
						$n2i = $('.secondary-navigation > .navigation__item > .navigation__item--link');
					$ns = $('.social-navigation');

					$cbtn = $(_o.close);
						$cbt = $(_o.close+'--bar.top');
						$cbb = $(_o.close+'--bar.bot');

					$b = $(_o.back);
					$o = $(_o.over);

					$lb = $(_o.loadingBrand);
					$ll = $(_o.loadingLoader);
					
					_InitRollOverElements();

					_GetMeasurements();
					_BuildInTimeLine();
					_BuildOutTimeLine();
					_BuildNavTimeLine();
					_BuildNavOutTimeLine();

					_InitTrigger();
					_BuildTriggerTimeLine();
				},

					_InitRollOverElements = function() {
						$mi.each(function() {
							var $$ = $(this),
								cnt = $$.text();
							
							var $mask = $('<span />')
								.addClass('navigation__item--mask')
								.appendTo($$)
							;

							var $hover = $('<span />')
								.html(cnt)
								.addClass('navigation__item--hover')
								.appendTo($mask)
							;								
						});
					},

					_GetMeasurements = function() {
						_ww = $w.width();
						_wh = $w.height();
						_l1aw = $l1a.width();

						isMobile = (_ww < 768);
					},

					// This animates from the loading screen to displaying the site's current page
					_BuildInTimeLine = function() {
						if (tli) { tli.clear(); }
						tli = new TimelineLite({ paused: true, delay: 1 });

						tli.add(new TweenLite($ll, .3, { css: { x: '+20', opacity: 0 }, ease: Power4.easeIn }))
							.add(new TweenLite($lb, .5, { css: { x: '+20', opacity: 0 }, ease: Power4.easeIn }), '-=.1')
							.add(new TweenLite($n, .2, { css: { xPercent: -100 }, ease: Expo.easeIn }), '-=.2')
							.add(new TweenMax($b, .8, { css: { skewX: "45deg", skewType: 'simple', x: -(_ww) }, ease: Expo.easeIn }), '-=.2')
						;
					},

					// This animates from the main menu to the loading screen
					_BuildOutTimeLine = function() {
						if (tlo) { tlo.clear(); }

						tlo = new TimelineLite({ paused: true, onStart: function() {
							$('.main-loading__loader--bar', $ll).css('opacity', 0);
						} });

						tlo
							.add(new TweenLite($cbtn, .2, { css: { x: '-20', opacity: 0 }, ease: Expo.easeOut }))
							.add(new TweenLite($m, .2, { css: { x: '-20', opacity: 0 }, ease: Expo.easeOut }))
							.add(new TweenMax($b, .8, { css: { skewX: "0deg", skewType: 'simple', x: 0 }, ease: Expo.easeOut }), '-=.2')
							.add(new TweenLite($ll, .3, { css: { x: 0, opacity: 1 }, ease: Power4.easeOut }))
							.add(new TweenLite($lb, .5, { css: { x: 0, opacity: 1 }, ease: Power4.easeOut }))
						;
					},

					// This animates the navigation into view
					_BuildNavTimeLine = function() {
						var backEase = (isMobile) ? Linear.easeNone : Expo.easeOut;

						if (tln) { tln.clear(); }

						tln = new TimelineLite({ paused: true });

						tln
							.set($mi, { css: { y: $mi.eq(0).parent().height() } })

							.add('start')
							.add(new TweenMax($b, .3, { css: { x: 0 }, ease: Power1.easeIn }))
							.add(new TweenMax($b, .6, { css: { skewX: "-45deg", skewType: 'simple', x: -(_ww) + (_ww - _wh), opacity: 1 }, ease: backEase }), '-=.3')
						;

						if (_ww < 768) {
							tln.add(new TweenMax($b, .4, { css: { skewX: "0deg", skewType: 'simple', x: 0 }, ease: Expo.easeOut }), '-=.2')
						}

						tln
							.add('visible', '-=.5')
							.add(new TweenMax($m, .2, { css: { opacity: 1, xPercent: 100 }, startAt: { opacity: 0, xPercent: 98 }, onComplete: function() {
								$b.css('pointer-events', 'initial');
								$m.css('pointer-events', 'initial');
							}, ease: Expo.easeOut}), 'visible-=.15')
							.add(new TweenMax($l2, .2, { css: { y: 0, opacity: 1 }, ease: Power1.easeOut }), 'visible')
							.add(new TweenMax($o, .6, { css: { opacity: 1 } , ease: Power1.easeOut }), 'visible')
							
							.staggerTo($mi, .2, { y: 0, ease: Power1.easeOut }, .1, 'visible+=.2')
							.add(new TweenMax($n2, .2, { css: { x: 0, opacity: 1 }, ease: Power1.easeOut }))
							.add(new TweenMax($ns, .2, { css: { x: 0, opacity: 1 }, ease: Power1.easeOut }))
							
							.add('close')
							.add(new TweenMax($cbt, 1, { css: { opacity: 1, rotation: 45 }, ease: Power4.easeInOut }), 'close')
							.add(new TweenMax($cbb, 1, { css: { opacity: 1, rotation: -45 }, ease: Power4.easeInOut }), 'close')
						;
					},

					// This animates the navigation out of view
					_BuildNavOutTimeLine = function() {
						if (tlno) { tlno.clear(); }

						tlno = new TimelineLite({ paused: true, onComplete: function() {
							$mi.each(function() {
								$(this).removeAttr('style');
							});
							$n2.removeAttr('style');
							$ns.removeAttr('style');
							$cbt.removeAttr('style');
							$cbb.removeAttr('style');
						}});

						tlno.add('start')
							.add(new TweenMax($m, .3, { css: { opacity: 0, xPercent: 98 }, ease: Power4.easeIn }), 'start')
							.add(new TweenMax($o, .3, { css: { opacity: 0 }, ease: Power4.easeIn }), 'start')
							.add(new TweenMax($b, .6, { css: { skewX: "45deg", skewType: 'simple', x: -(_ww), opacity: .95 }, ease: Power4.easeIn }), 'start')
						;
					},

					_InitTrigger = function() {
						// Break apart the letters in MENU.
						var letters = $tt.text().split('');

						// Build double span for each letter
						var $ds = $('<span />');
						letters.map(function(l) {
							var $ltr = $('<span />')
								.addClass('main-header__menu__letter')
								.appendTo($ds);
								var $ltr1 = $('<span />')
									.text(l)
									.addClass('main-header__menu__letter--top')
									.appendTo($ltr);
								var $ltr2 = $('<span />')
									.text(l)
									.addClass('main-header__menu__letter--bottom')
									.appendTo($ltr);
						});
						$tt.empty().append($ds);
					},

					// This animates the main menu hover effect
					_BuildTriggerTimeLine = function() {
						if (tlt) { tlt.clear(); }
						tlt = new TimelineLite({ paused: true });

						tlt
							.add(new TweenLite($tbk, .4, { css: { scaleX: 1 }, ease: Expo.easeOut }))
							.add(new TweenLite($tbk, 1, { css: { backgroundColor: 'rgba(0, 0, 0, .7)' }, ease: Power1.easeOut }), '-=.5')
							//.add(new TweenLite($l1, .5, { css: { yPercent: -50 }, ease: Expo.easeInOut }), '-=.3')
						;

						if (tltr) { tltr.clear(); }
						tltr = new TimelineLite();
						tltr.add('start');
						$(' > span > span', $tt).each(function(i) {
							var $$ = $(this),
								lh = $$.height() * .5;
							tltr.add(new TweenLite($('span', $$).eq(0), .3, { css: { opacity: 1, y: lh }, ease: Power1.easeOut }), 'start+=' + (i * .1));
							tltr.add(new TweenLite($('span', $$).eq(1), .3, { css: { opacity: 0, y: lh }, ease: Power1.easeOut }), 'start+=' + (i * .1));
						});
						tltr.addPause(0);
					},


				_OnTriggerClick = function(e) {
					e.preventDefault();
					tln.seek(0).play();
				},

				_OnCloseClick = function(e) {
					e.preventDefault();
					_CloseNav();
				},

					_CloseNav = function() {
						tlno.restart();
						$b.css('pointer-events', 'none');
						$m.css('pointer-events', 'none');
					},

				_OnTriggerHover = function(e) {
					tlt.play().timeScale(1);
					tltr.restart();
				},

				_OnTriggerOut = function(e) {
					tlt.reverse().timeScale(1.8);
				},

				_OnNavItemClick = function(e) {
					var $$ = $(e.currentTarget),
						t = $$.prop('target');

					if (t) { return; }
					
					if ($$.parent().hasClass('close-nav')) {
						_CloseNav();
					} else {
						e.preventDefault();
						tlo.eventCallback('onComplete', function() {
							window.location = $$.prop('href');
						}).restart();
					}
				},

				_OnWindowResize = debounce(function(e) {
					_GetMeasurements();
					_BuildNavTimeLine();
					_BuildInTimeLine();
					_BuildOutTimeLine();
					_BuildNavTimeLine();
					_BuildNavOutTimeLine();
					_BuildTriggerTimeLine();

					tlno.progress(1).invalidate();
					tln.invalidate();
					tli.invalidate();
					tlo.invalidate();
					tlt.invalidate();
					tltr.invalidate();

					$b.css('pointer-events', 'none');
					$m.css('pointer-events', 'none');
				}, 250),

				_BindEvents = function () {
					$th.hover(_OnTriggerHover, _OnTriggerOut);
					$t.click(_OnTriggerClick);
					$w.on('resize', _OnWindowResize);
					$cbtn.click(_OnCloseClick);

					$mi.click(_OnNavItemClick);
					$n2i.click(_OnNavItemClick);
				},

				init = (function() {
					_InitObjects();
					_BindEvents();

					tli.play();
					setTimeout(function() { tltr.play(); }, 2000);
				})();
			}) ($c, options);
	};

	$.fn.mainMenu = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('mainMenu')) {
				var plugin = new $.mainMenu(this, options);
				$(this).data('mainMenu', plugin);
			}
		});
	};
})(jQuery);
